import Immutable, { Record } from 'immutable';
import { moment } from 'omni-common-ui';
import category from './category';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
    case 'studentId':
      return [key, `${val}`];
    case 'category':
      return [key, getCategory(val)];
    case 'notedDateTimeUtc':
      return [key, moment.utc(val)];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

function getCategory(categoryCode) {
  return category[categoryCode.toLowerCase()];
}

const NoteRecord = Record({
  id: undefined,
  entityId: undefined,
  noteName: undefined,
  notedByUserId: undefined,
  notedDateTimeUtc: undefined,
  groupId: undefined,
  groupCode: undefined,
  fullCourseTypeLevelCode: undefined,
  category: undefined,
  content: undefined,
  studentId: undefined,
});

class Note extends NoteRecord {
  static create(data) {
    return new Note(data).mapEntries(reviver);
  }
}

export default Note;



// WEBPACK FOOTER //
// ./containers/Student/Note/model.js